import { render, staticRenderFns } from "./EditSupplierStockTemplateComponent.vue?vue&type=template&id=5ebc9449&"
import script from "./EditSupplierStockTemplateComponent.vue?vue&type=script&lang=js&"
export * from "./EditSupplierStockTemplateComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports